<div *ngIf="showProgressBar">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div align="center" class="title">
  <h3>APU</h3>
  <b>Supply Name: </b>{{supplyName}} &nbsp;
  &nbsp;
  <b>Location: </b> {{sysContact}}
  <br>
  <b>Location Information: </b> {{sysLocation}}
</div>
<br>
<mat-dialog-content class="mat-typography" align="center">
  <div>
    <form id="apuFormGroup" [formGroup]="apuFormGroup">
      <mat-form-field class="mat-form-field-infix-class">
        <mat-select placeholder="APU - Make Model" formControlName="apuMakeModel">
          <mat-option *ngFor="let apuMakeModel of apuMakeModels" [value]="apuMakeModel.description">
            {{apuMakeModel.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput placeholder="APU Serial Number" formControlName="apuSerialNumber">
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <mat-select placeholder="APU Device Id" formControlName="apuDeviceId">
          <mat-option *ngFor="let deviceId of deviceIds" [value]="deviceId">
            {{deviceId}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput placeholder="APU Runtime" formControlName="apuRunTime">
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <mat-select placeholder="ECM/ACM" formControlName="ecmAcm">
          <mat-option *ngFor="let ecmAcm of ecmAcms" [value]="ecmAcm">
            {{ecmAcm}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput [matDatepicker]="picker" placeholder="Date APU Installed" formControlName="dateApuInstalled">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <mat-select placeholder="APU Output Voltage Rating" formControlName="apuOpVltgRating">
          <mat-option *ngFor="let apuOpVltgRating of apuOpVltgRatings" [value]="apuOpVltgRating">
            {{apuOpVltgRating}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput placeholder="APU No-Load Voltage" formControlName="apuNoLoadVltg">
        <mat-error *ngIf="apuFormGroup.get('apuNoLoadVltg').errors?.validateNumber">
          APU No-Load Voltage <strong>Should</strong> only include numbers !!
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput placeholder="APU Load Voltage" formControlName="apuLoadVltg">
        <mat-error *ngIf="apuFormGroup.get('apuLoadVltg').errors?.validateNumber">
          APU Load Voltage <strong>Should</strong> only include numbers !!
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <mat-select placeholder="APU Enclosure - Make/Model" formControlName="apuEnclosure">
          <mat-option *ngFor="let apuEnclosure of apuEnclosures" [value]="apuEnclosure">
            {{apuEnclosure}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <mat-select placeholder="NG/LP" formControlName="ngLp">
          <mat-option *ngFor="let ngLp of ngLps" [value]="ngLp">
            {{ngLp}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <mat-select placeholder="NG Provider(If used)" formControlName="ngProvider">
          <mat-option *ngFor="let ngProvider of ngProvideres" [value]="ngProvider.naturalGasProvider1">
            {{ngProvider.naturalGasProvider1}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput placeholder="LP Tank Capacity" formControlName="lpTankCapacity">
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput placeholder="Number Of Tanks Installed" formControlName="noOfTanksInstalled">
        <mat-error *ngIf="apuFormGroup.get('noOfTanksInstalled').errors?.validateNumber">
          Number Of Tanks Installed <strong>Should</strong> only include numbers !!
        </mat-error>
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-button cdkFocusInitial [disabled]="apuFormGroup.invalid" (click)="saveApuChanges()">Save APU
    Changes</button>
</mat-dialog-actions>